<template>
  <div class="venn-container">
    <svg :width="width" :height="height" viewBox="0 0 300 220" style="height: 300px;">
      <!-- Circles -->
      <circle cx="120" cy="100" r="70" class="venn-circle venn-pval" />
      <circle cx="180" cy="100" r="70" class="venn-circle venn-fdr" />
      <circle cx="150" cy="160" r="70" class="venn-circle venn-fc" />
      
      <!-- Labels for each region -->
      <!-- P-value only -->
      <text x="75" y="80" class="venn-count">{{ data.pOnly || 0 }}</text>
      <!-- FDR only -->
      <text x="215" y="80" class="venn-count">{{ data.fdrOnly || 0 }}</text>
      <!-- FC only -->
      <text x="150" y="205" class="venn-count">{{ data.fcOnly || 0 }}</text>
      <!-- P ∩ FDR (not FC) -->
      <text x="150" y="70" class="venn-count">{{ data.pAndFdr || 0 }}</text>
      <!-- P ∩ FC (not FDR) -->
      <text x="100" y="145" class="venn-count">{{ data.pAndFc || 0 }}</text>
      <!-- FDR ∩ FC (not P) -->
      <text x="195" y="145" class="venn-count">{{ data.fdrAndFc || 0 }}</text>
      <!-- All three (center) -->
      <text x="150" y="115" class="venn-count venn-center">{{ data.allThree || 0 }}</text>
      
      <!-- Circle labels -->
      <text x="55" y="35" class="venn-label">P-value</text>
      <text x="210" y="35" class="venn-label">FDR</text>
      <text x="150" y="245" class="venn-label">|log2FC|</text>
    </svg>
    <div class="venn-legend">
      <span class="legend-item"><span class="legend-dot legend-pval"></span>P-value ({{ data.pval || 0 }})</span>
      <span class="legend-item"><span class="legend-dot legend-fdr"></span>FDR ({{ data.fdr || 0 }})</span>
      <span class="legend-item"><span class="legend-dot legend-fc"></span>|log2FC| ({{ data.fc || 0 }})</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VennDiagram',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    width: {
      type: Number,
      default: 300
    },
    height: {
      type: Number,
      default: 220
    }
  }
}
</script>

<style scoped>
.venn-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
}

.venn-circle {
  fill-opacity: 0.3;
  stroke-width: 2;
}

.venn-pval {
  fill: #3b82f6;
  stroke: #2563eb;
}

.venn-fdr {
  fill: #10b981;
  stroke: #059669;
}

.venn-fc {
  fill: #f59e0b;
  stroke: #d97706;
}

.venn-count {
  font-size: 12px;
  font-weight: 600;
  fill: #1f2937;
  text-anchor: middle;
  dominant-baseline: middle;
}

.venn-center {
  font-size: 14px;
  font-weight: 700;
  fill: #16a34a;
}

.venn-label {
  font-size: 11px;
  font-weight: 500;
  fill: #6b7280;
  text-anchor: middle;
}

.venn-legend {
  display: flex;
  gap: 12px;
  margin-top: 8px;
  flex-wrap: wrap;
  justify-content: center;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #4b5563;
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.legend-pval {
  background: #3b82f6;
}

.legend-fdr {
  background: #10b981;
}

.legend-fc {
  background: #f59e0b;
}
</style>
